import NotFound from '@/views/NotFound.vue'
import HomeLanding from '../views/HomeLanding'

export default [
    {
        name: 'home',
        path: '/:name-v:id(\\d+)',
        component: HomeLanding,
        props: route => ({ id: Number.parseInt(route.params.id) }),
    },
    {
        name: 'tv-view',
        path: '/:name-tv:id(\\d+)',
        component: () => import(/* webpackChunkName: "tv-view" */ '../views/TvView.vue'),
        props: route => ({ id: Number.parseInt(route.params.id) }),
    },
    { path: '*', component: NotFound }
]
